import * as React from 'react';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';

export default function DateRangeField({onDateRangeChange}) {
  const [value, setValue] = React.useState([
    dayjs('2023-04-17'),
    dayjs('2023-04-21'),
  ]);

 

  const handleDateRangeChange = (newValue) => {
    setValue(newValue);
    onDateRangeChange(newValue);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    
       
          <DateRangePicker
            value={value}
            required
            onChange={handleDateRangeChange}
          />
        
    
    </LocalizationProvider>
  );
}

